import { User } from '../types'

export function canEditField(user: User | undefined, model: string, field: string) {
	return user?.fieldPermissions?.some(p => p.model === model && p.field === field && p.permission === 'edit') ?? false
}

export function isHiddenField(user: User | undefined, model: string, field: string) {
	return user?.fieldPermissions?.some(p => p.model === model && p.field === field && p.permission === 'hide') ?? false
}

export function canDeleteView(user: User | undefined, folder: string, model: string, defaultDeleting: boolean = false) {
	const explicitPermission = user?.viewPermissions?.find(
		p =>
			p.folder === folder &&
			p.model === model &&
			(p.permission === 'delete_allow' || p.permission === 'delete_deny')
	)
	return explicitPermission ? explicitPermission.permission === 'delete_allow' : defaultDeleting
}

export function canInsertingView(
	user: User | undefined,
	folder: string,
	model: string,
	defaultInserting: boolean = false
) {
	const explicitPermission = user?.viewPermissions?.find(
		p =>
			p.folder === folder &&
			p.model === model &&
			(p.permission === 'insert_allow' || p.permission === 'insert_deny')
	)
	return explicitPermission ? explicitPermission.permission === 'insert_allow' : defaultInserting
}

export function canExportView(user: User | undefined, folder: string, model: string) {
	if (user?.exportWhitelist) {
		return true
	}
	const explicitPermission = user?.viewPermissions?.find(
		p =>
			p.folder === folder &&
			p.model === model &&
			(p.permission === 'export_allow' || p.permission === 'export_deny')
	)
	return explicitPermission ? explicitPermission.permission === 'export_allow' : false
}
